// 出水标准树
export const EFFLUENT_TREE = [
  {
    id: 1,
    label: "根节点",
    parentId: 0,
    type: null,
    children: [
      {
        id: 2,
        label: "净水标准",
        parentId: 1,
        type: null,
        children: [
          {
            id: 4,
            label: "一级A标准",
            parentId: 2,
            type: 1,
            children: [],
          },
          {
            id: 5,
            label: "准Ⅲ类水标准",
            parentId: 2,
            type: 2,
            children: [],
          },
          {
            id: 6,
            label: "准Ⅳ类水标准",
            parentId: 2,
            type: 3,
            children: [],
          },
          {
            id: 7,
            label: "B51",
            parentId: 2,
            type: null,
            children: [
              {
                id: 8,
                label: "城镇",
                parentId: 1,
                type: 4,
                children: [],
              },
              {
                id: 9,
                label: "工业",
                parentId: 1,
                type: 5,
                children: [],
              },
            ],
          },
        ],
      },
      {
        id: 3,
        label: "供水标准",
        parentId: 1,
        type: null,
        children: [
          {
            id: 10,
            label: "生活饮用水标准",
            parentId: 3,
            type: 6,
            children: [],
          },
        ],
      },
    ],
  },
];
